import React from 'react';
import { CheckboxContainer } from './styles';

export const Checkbox: React.FC<any> = ({ title, active, onClick }) => {
  return (
    <CheckboxContainer onClick={onClick} active={active}>
      {title}
    </CheckboxContainer>
  );
}
